import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Loader2 } from "lucide-react";
import { useGtt } from "../lib/gtt";
import { useMarket } from "../lib/store";
import { useSubscribe, useTick, useMeta } from "../lib/socket";
import { InstrumentPicker } from "./InstrumentPicker";
import { GttForm } from "./GttForm";
import { AlertForm } from "./AlertForm";

function Body({ d, k }) {
  useSubscribe([k]);
  const inst = useMeta(k);
  const tick = useTick(k);
  if (!inst || (!tick?.ltp && !d.edit)) return <div className="py-10 grid place-items-center text-muted-foreground"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  return d.kind === "gtt" ? <GttForm inst={inst} tick={tick} edit={d.edit} side={d.side} pre={d.pre} /> : <AlertForm inst={inst} tick={tick} />;
}

export function GttDialog() {
  const { dialog: d, close, openGtt, openAlert } = useGtt();
  const k = d?.edit?.instrument_key || d?.key;
  const inst = useMarket((s) => s.meta[k]);
  const title = d?.kind === "gtt" ? (d?.edit ? "Modify GTT" : "New GTT order") : "New price alert";
  const pick = (key) => (d.kind === "gtt" ? openGtt({ key, side: d.side }) : openAlert({ key }));
  return (
    <Dialog open={!!d} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="sm:max-w-[460px] bg-card" data-testid="gtt-dialog">
        <DialogHeader>
          <DialogTitle className="font-display" data-testid="gtt-dialog-title">{title}{inst ? ` · ${inst.trading_symbol}` : ""}</DialogTitle>
          <DialogDescription className="text-[11.5px]">
            {d?.kind === "gtt" ? "Good Till Triggered — sits on the server and turns into a limit order when price hits your trigger." : "Get notified when price or day change crosses your level."}
          </DialogDescription>
        </DialogHeader>
        {d && (k ? <Body key={`${d.kind}-${k}-${d.edit?.id || ""}`} d={d} k={k} /> : <InstrumentPicker onPick={pick} />)}
      </DialogContent>
    </Dialog>
  );
}
